<template>
  <div class="modal-body align-center ">
    <b-icon icon="exclamation-circle-fill" class="color-yellow" style="width: 26px; height: 26px"></b-icon>
    <div class="title color-yellow title-modal">
      {{title.find((element) => element.key === type).value}}
    </div>
    <div class="w-100 d-flex justify-content-center mt-2 content-modal">
      <div v-if="type === 'limit_account'" style="width: 332px">
        <span>Vui lòng liên hệ qua hotline: <span class="text-blue">1900 633 841</span> để mua thêm tài khoản hoặc lựa chọn các tài khoản bạn muốn giữ lại tại đây.</span>
      </div>
      <div v-if="type === 'almost_expired'" style="width: 362px">
        <span>Tài khoản <span class="text-blue">Chat</span> của bạn sẽ hết hạn trong 2 ngày. Sản phẩm sẽ ngừng cung cấp dịch vụ và xóa dữ liệu.</span>
      </div>
      <div v-if="type === 'expired'" style="width: 332px">
        <span>Tài khoản <span class="text-blue">Chat</span> của bạn đã hết hạn dùng thử. Vui lòng nâng cấp gói dịch vụ để tiếp tục sử dụng!</span>
      </div>
    </div>
    <div v-if="globalData.isAdmin" class="line"></div>
    <b-button v-if="globalData.isAdmin" variant="primary" class="mt-2" @click="handleButton">{{type === 'limit_account'? 'Tuỳ chọn tài khoản': 'Đi tới trang nâng cấp'}}</b-button>
  </div>
</template>

<script>
import AccountManagementModal from "@/views/components/modals/AccountManagementModal";

export default {
  name: "NotiAccountModal",
  props: ['type'], //limit_account, almost_expired, expired
  data: () => {
    return {
      title : [
        {key: 'limit_account', value : 'Vượt quá số lượng tài khoản liên kết'},
        {key: 'almost_expired', value : 'Tài khoản của bạn sắp hết hạn dùng thử'},
        {key: 'expired', value : 'Tài khoản hết hạn dùng thử'},
      ]
    }
  },
  methods : {
    closeModal(){
      this.$emit('close');
    },

    handleButton(){
      if(this.type === 'limit_account'){
        this.$emit('close')
        this.$modal.show(AccountManagementModal, null, {width: '680px', clickToClose: false, draggable: false});
      }else {
        window.location.href = 'https://admin.salework.co/billing/bill-create?appName=CHAT';
      }
    }
  }
}
</script>

<style scoped>
.modal-body{
  width: 480px;
  height: auto;
}

.color-yellow{
  color: #D08B20;
}

.title-modal{
  font-weight: 700;
  font-size: 16px;
}

.text-blue{
  font-weight: 700;
  color: #327AE7;
}

.content-modal{
  font-size: 16px;
}

.line {
  width: 332px;
  border-top: #ECECEC 1px solid;
  margin-left: 54px;
  margin-top: 20px;
}
</style>